module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.16460f7.woff";